module.exports = '4.2.0';



// WEBPACK FOOTER //
// ./src/version.js